import * as yup from "yup";

export const schema = yup.object().shape({
  name: yup.string().required("Поле обязательно для заполнения"),
  code: yup.string().required("Поле обязательно для заполнения"),
  status: yup.object().shape({
    label: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
    value: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
  }),
  level: yup.object().shape({
    label: yup.string().required("Поле обязательно для заполнения"),
    value: yup.number().required("Поле обязательно для заполнения").nullable(),
  }),
  certificateValidityPeriod: yup
    .number()
    .transform((value, originalValue) => {
      if (originalValue === "") return null;
      return value;
    })
    .nullable()
    .notRequired()
    .typeError("Значение должно быть числом")
    .when([], {
      is: (value) => value != null,
      then: (schema) => schema.min(1, "Значение должно быть положительным"),
    }),
});
